export const navItems = [
  { 
    icon: 'BookOpen', 
    label: 'Dashboard', 
    path: '/dashboard',
    roles: ['student', 'admin'] 
  },
  { 
    icon: 'GraduationCap', 
    label: 'Course Catalog', 
    path: '/courses',
    roles: ['student', 'admin'] 
  },
  { 
    icon: 'PlayCircle', 
    label: 'My Courses', 
    path: '/my-courses',
    roles: ['student', 'admin'] 
  },
  { 
    icon: 'MessageSquare', 
    label: 'Community', 
    path: '/community',
    roles: ['student', 'admin'] 
  },
  { 
    icon: 'Calendar', 
    label: 'Schedule', 
    path: '/schedule',
    roles: ['student', 'admin'] 
  },
  { 
    icon: 'User', 
    label: 'Profile', 
    path: '/profile',
    roles: ['student', 'admin'],
    bottom: true 
  }
];

export const userMenu = [
  {
    label: 'Settings',
    path: '/settings',
    icon: 'Settings'
  },
  {
    label: 'Logout',
    path: '/logout',
    icon: 'LogOut'
  }
];
